/** Readonly transaction mode */ const ReadOnly = "readonly";
/** Readwrite transaction mode */ const ReadWrite = "readwrite";
/** Mode for indexedDB transactions */ export const Mode = {
    ReadOnly: ReadOnly,
    ReadWrite: ReadWrite
};
/** IndexedDB related errors for /openDB/put/get/delete operations
 * Ref Link: https://developer.mozilla.org/en-US/docs/Web/API/IDBRequest/error
 */ export var IndexedDBErrors = /*#__PURE__*/ function(IndexedDBErrors) {
    IndexedDBErrors["AbortError"] = "AbortError";
    IndexedDBErrors["ConstraintError"] = "ConstraintError";
    IndexedDBErrors["DataCloneError"] = "DataCloneError";
    IndexedDBErrors["DataError"] = "DataError";
    IndexedDBErrors["InvalidAccessError"] = "InvalidAccessError";
    IndexedDBErrors["InvalidStateError"] = "InvalidStateError";
    IndexedDBErrors["NotFoundError"] = "NotFoundError";
    IndexedDBErrors["QuotaExceededError"] = "QuotaExceededError";
    IndexedDBErrors["ReadOnlyError"] = "ReadOnlyError";
    IndexedDBErrors["TransactionInactiveError"] = "TransactionInactiveError";
    IndexedDBErrors["UnknownError"] = "UnknownError";
    IndexedDBErrors["VersionError"] = "VersionError";
    IndexedDBErrors["BlockedError"] = "BlockedError";
    IndexedDBErrors["NotReadableError"] = "NotReadableError";
    return IndexedDBErrors;
}({});
